import { useCallback, useMemo, useRef } from 'react'

import { t } from 'i18next'

import { SidePanelModal } from '~/components/SidePanelModal'

import DrawerContent from './DrawerContent'

const Drawer = <T extends string, TCard extends CardSelectorItem<T>>({
  cards,
  hiddenCards,
  defaultCardsToCustomize,
  defaultHiddenCards,
  isOpen,
  onClose,
  onChange,
  onReset
}: CardSelectorDrawerProps<T, TCard>) => {
  const messageId = useRef('card-selector-drawer')

  const handleClose = useCallback(
    (callback?: () => void) => {
      onClose(callback)
    },
    [onClose]
  )

  const message = useMemo<SidePanelMessage>(
    () => ({
      id: messageId.current,
      title: t('rm:metrics.cards.customize.title'),
      size: 'fluid',
      content: (
        <DrawerContent
          cards={cards}
          hiddenCards={hiddenCards}
          defaultCardsToCustomize={defaultCardsToCustomize}
          defaultHiddenCards={defaultHiddenCards}
          isOpen={isOpen}
          onClose={onClose}
          onChange={onChange}
          onReset={onReset}
        />
      )
    }),
    [
      cards,
      hiddenCards,
      defaultCardsToCustomize,
      defaultHiddenCards,
      isOpen,
      onClose,
      onChange,
      onReset
    ]
  )

  if (!isOpen) return null

  return <SidePanelModal message={message} onClose={handleClose} />
}

export default Drawer
